export default {"src":"/_next/static/media/Wordcloud_404.35bf73d4.svg","height":395,"width":1110,"blurWidth":0,"blurHeight":0};